import React, { useState } from 'react';
import { PERSONA_FACES } from '@/lib/personaFaces';
import TokenMessagingBanner from '@/components/TokenMessagingBanner';

export default function AgentZero() {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [messageIdCounter, setMessageIdCounter] = useState(0);
  
  const agentZero = PERSONA_FACES.agentZero;

  const handleSend = () => {
    if (!input.trim()) return;
    
    const newUserMsg = {
      id: `msg-${messageIdCounter}`,
      role: 'user',
      content: input
    };
    setMessages([...messages, newUserMsg]);
    setMessageIdCounter(messageIdCounter + 1);
    
    // Placeholder response
    setTimeout(() => {
      setMessages(prev => [...prev, {
        id: `msg-${messageIdCounter + 1}`,
        role: 'assistant',
        content: '...'
      }]);
      setMessageIdCounter(messageIdCounter + 2);
    }, 800);
    
    setInput('');
  };

  return (
    <div className="min-h-screen">
      <TokenMessagingBanner />
      <div className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="glass-panel p-8 mb-8 text-center">
          <img 
            src={agentZero.avatarUrl} 
            alt="Agent Zero"
            className="w-32 h-32 rounded-full mx-auto mb-4 ring-4 ring-red-500/30"
          />
          <h1 className="font-unbounded text-4xl text-white mb-2">Agent Zero</h1>
          <p className="text-red-400 text-lg">{agentZero.role}</p>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            The Silent Operator. Truth Gate Middleware. Every claim passes through Agent Zero's verification layer. 95% confidence or rejection.
          </p>
        </div>

        {/* Chat Interface Placeholder */}
        <div className="glass-panel p-6">
          <div className="space-y-4 mb-4 min-h-[300px] max-h-[500px] overflow-y-auto">
            {messages.length === 0 ? (
              <div className="text-center text-gray-500 py-20">
                Agent Zero observes. Speak your truth...
              </div>
            ) : (
              messages.map((msg) => (
                <div key={msg.id} className={`p-4 rounded-lg ${msg.role === 'user' ? 'bg-red-900/20 ml-auto max-w-[80%]' : 'bg-gray-800/50 mr-auto max-w-[80%]'}`}>
                  <p className="text-white">{msg.content}</p>
                </div>
              ))
            )}
          </div>

          <div className="flex gap-2">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Submit statement for verification..."
              className="flex-1 px-4 py-3 bg-black/50 border border-red-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-red-500"
            />
            <button
              onClick={handleSend}
              className="px-6 py-3 bg-red-500 hover:bg-red-600 rounded-lg font-semibold transition"
            >
              Verify
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
